import { memo } from "react";

import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { FooterLinks } from "./FooterLinks";

type Props = {
  additionalDisclaimer?: string;
  containerStyle?: string;
  isLoggedIn: boolean;
  small?: boolean;
  removePageContainerPadding?: boolean;
  pageContainerVariant?: "gp" | "lp";
  linkClassName?: string;
};

export const Footer = memo(
  ({
    additionalDisclaimer,
    containerStyle,
    isLoggedIn,
    small,
    removePageContainerPadding,
    pageContainerVariant,
    linkClassName: className,
  }: Props) => {
    const {
      features: { footer },
    } = usePublicConfig();

    return (
      <footer
        className={cnTwMerge(
          "bottom-0 flex flex-col gap-6 py-6 text-text/secondary",
          {
            "px-4  md:px-0 ": !removePageContainerPadding,
            "container-padding-lp":
              removePageContainerPadding && pageContainerVariant === "lp",
            "container-padding-gp":
              removePageContainerPadding && pageContainerVariant === "gp",
          },
          containerStyle,
        )}
      >
        <div
          className={cnTwMerge("flex gap-4 md:gap-8 flex-col md:flex-row", {
            "pt-4": isTruthy(small),
          })}
        >
          <FooterLinks className={className} isLoggedIn={isLoggedIn} />
        </div>
        <div className={cnTwMerge("w-full body-small-regular grow")}>
          {isTruthy(additionalDisclaimer) ? (
            <div className="whitespace-pre-line body-small-regular">
              {additionalDisclaimer}
            </div>
          ) : null}
          <p className="text-left body-small-regular">
            {footer.text.replace(
              "{{year}}",
              new Date().getFullYear().toString(),
            )}
          </p>
        </div>
      </footer>
    );
  },
);

export function getAppVersion() {
  const element = document.getElementById("app-build-version");

  return element?.getAttribute("build-version");
}
